module.exports = __webpack_public_path__ + "assets/redpack-box-d21915c1.png";